module.exports = __webpack_public_path__ + "8169ac3b9b56dfd378075a700a1a9afb.pdf";